import script from "./new.vue?vue&type=script&setup=true&lang=js"
export * from "./new.vue?vue&type=script&setup=true&lang=js"

import "./new.vue?vue&type=style&index=0&id=38d5b8e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d5b8e2"]])

export default __exports__